import products from 'data/filo-tag.json'

export function setProductIdBasedOnLang(productId){
    // const LANG = document.documentElement.lang.substring(0, 2).toLowerCase();

    let PASSED_PRODUCT_ID_LANG = ""

    Object.entries(products).forEach(([lang, productList]) => {

        const IDS = Object.keys(productList)

        const foundProduct = IDS.find(id => id === productId)

        if(foundProduct !== undefined && foundProduct !== null && foundProduct !== ""){
            PASSED_PRODUCT_ID_LANG = lang
        }

    })

    return PASSED_PRODUCT_ID_LANG
    

}
